import Axios from "axios";
export const client = (config)=>{
    const instance = Axios.create({
        paramsSerializer: {
            indexes: null
        }
    });
    /**
   * we rewrite the urls for api2 to the api for the new server
   */ return instance(config).then(({ data })=>{
        return Promise.resolve(data);
    }).catch((error)=>{
        return Promise.reject({
            ...error?.response?.data?.code ? {
                code: error.response.data.code
            } : {},
            ...error?.response?.data?.detail ? {
                detail: error.response.data.detail
            } : {},
            message: error?.response?.data?.message ?? 'an unknown error has occurred',
            ...error?.response?.data?.meta ? {
                meta: error.response.data.meta
            } : {},
            status: error?.status ?? error?.response?.status ?? error?.response?.data?.status ?? 500
        });
    });
};

//# sourceMappingURL=client.js.map